angular.module('env.context', [])

    // Context for customisation engine
    .service('context', function context($q, $log, EventingMixin, usersRepository, authService) {
        var _this = this;
        _.extend(this, new EventingMixin(['changed']));

        /**
         * Current user object for customisation engine
         * @type {Object}
         */
        var _currentUser;

        authService.events.on('login', resetCurrentUser);
        authService.events.on('loginFailed', resetCurrentUser);
        authService.events.on('logout', resetCurrentUser);
        authService.events.on('sessionExpired', resetCurrentUser);

        /**
         * Reset current user for customisation engine
         */
        function resetCurrentUser() {
            _currentUser = null;
        }

        /**
         * Get current user for customisation engine
         * @returns {*} current user plain object
         */
        function getUserAsync() {
            _currentUser = null;
            return usersRepository.getCurrentUser().then(function (restUser) {
                _currentUser = restUser.unRestClone();
                _this.events.raise('changed', {user: _currentUser});
                return _currentUser;
            });
        }

        /**
         * Promise.
         * Gets current user (and caches it in private variable). Also subscribes to the login/logout
         * events and resets the cached user object.
         * Since the caller may call it during configuration stage, it checks inside if the services (repos)
         * are available for use, otherwise do nothing.
         */
        function getCurrentUser() {
            return $q.when(!_currentUser ? getUserAsync() : _currentUser);
        }

        /**
         * Promise.
         * Gets current context object adding supplied data to it as well as current user object.
         * @param data - data to set onto context object
         */
        _this.getCurrent = function (data) {
            var dataToSet = data || {};
            var context = _.clone(dataToSet); // shallow copy

            return getCurrentUser().then(function (user) {
                context.user = user;
                return context;

            }, function (error) {
                $log.warn("Can't fetch current user info for the current context. Details: %s",
                    error.status && error.statusText ? error.status + " " + error.statusText : error);
                return context;
            });
        };

        return _this;
    }
);